import * as AT from '../constants/actionTypes'

/**
 * Request reducer
 * @param {*} state 
 * @param {*} action 
 */
function request(state = { requests: [], allRequests: [] }, action) {
	switch (action.type) {
		case AT.PROFILE_LOGOUT:
		case AT.RESET_ALL:
			return Object.assign({}, state, {
				requests: [],
				allRequests: []
			})
		case AT.REQUEST_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				requests: [],
				allRequests: [],
				error: undefined
			})
		case AT.REQUEST_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.REQUEST_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				requests: action.payload.requests,
				error: undefined
			})
		case AT.REQUEST_ALL_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				requests: [],
				allRequests: [],
				error: undefined
			})
		case AT.REQUEST_ALL_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.REQUEST_ALL_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				allRequests: action.payload.allRequests,
				error: undefined
			})			
		// Remove a request
		case AT.REQUEST_REMOVING_STARTED:
			return Object.assign({}, state, {
				isRemoving: true,
				error: undefined
			})
		case AT.REQUEST_REMOVING_FAILED:
			return Object.assign({}, state, {
				isRemoving: false,
				error: action.payload.error
			})
		case AT.REQUEST_REMOVING_FINISHED:
			return Object.assign({}, state, {
				isRemoving: false,
				requests: state.requests.filter( r => r.id !== action.payload.id ),
				error: undefined
			})
		// Request for new target
		case AT.REQUEST_ADD_NEW_TARGET_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.REQUEST_ADD_NEW_TARGET_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.REQUEST_ADD_NEW_TARGET_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				error: undefined
			})		
		case AT.REQUEST_UI_CLEAR:
			return Object.assign({}, state, {
				error: undefined,
				message: undefined,
				checkedLicense: undefined
			})
		// Request for address re-use with different target
		case AT.REQUEST_ADD_EXISTING_ADDRESS_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.REQUEST_ADD_EXISTING_ADDRESS_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.REQUEST_ADD_EXISTING_ADDRESS_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				error: undefined
			})				
		// Request for new address
		case AT.REQUEST_ADD_NEW_ADDRESS_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.REQUEST_ADD_NEW_ADDRESS_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.REQUEST_ADD_NEW_ADDRESS_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				error: undefined
			})	
		// License check before request
		case AT.REQUEST_CHECK_LICENSE_STARTED:
			return Object.assign({}, state, {
				message: undefined,
				error: undefined
			})
		case AT.REQUEST_CHECK_LICENSE_FAILED:
			return Object.assign({}, state, {
				error: undefined,
				message: 'Már létező pecsétszám, az alábbi orvoshoz rendelve: ' + action.payload.name,
				checkedLicense: action.payload.license
			})
		case AT.REQUEST_CHECK_LICENSE_FINISHED:
			return Object.assign({}, state, {
				error: undefined,
				message: undefined,
				checkedLicense: undefined
			})			
		case AT.REQUEST_SETSTATUS_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.REQUEST_SETSTATUS_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.REQUEST_SETSTATUS_FINISHED:
			let changedR = state.requests.filter( p => p.id === action.payload.id)[0];
			changedR.isProcessed = action.payload.status
			return Object.assign({}, state, {
				isSaving: false,
				requests: [ ...state.requests.filter( p => p.id !== action.payload.id), changedR ],
				error: undefined
			})							
		default:
			return state;
	}
}

export default request;